module.exports = __webpack_public_path__ + "assets/shutiao.e53c9363.svg";